import {inject, Injectable} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {InsightsService} from '../services/insights/insights.service';
function normalizeUrl(url: string): string {
  return url.replace(/\/\d+(\b|\/)/g, '/{id}$1');
}
@Injectable()
export class ApiResponseSizeInterceptor implements HttpInterceptor {
  private insightService = inject<InsightsService>(InsightsService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          let size = 0;

          if (event.body) {
            if (typeof event.body === 'string') {
              size = new Blob([event.body]).size;
            } else {
              size = new Blob([JSON.stringify(event.body)]).size;
            }
          }
          const normalizedUrl = normalizeUrl(req.url);

          this.insightService.logMetric('ApiResponseSize', size, {
            url: normalizedUrl,
            type: req.method,
          });
        }
      })
    );
  }
}
